const map = {
  '0': {
    label: {
      short: 'Exceptional',
    },
    letter: 'A',
    colour: {
      bg: {
        high: 'bg-janascore-a-h',
        low: 'bg-janascore-a-l',
        text: 'text-white'
      },
      border: {
        high: 'border-janascore-a-h',
        low: 'border-janascore-a-l'
      },
      hex: {
        high: '#018A2C',
        low: '#018A2C80'
      }
    }
  },
  '-1': {
    label: {
      short: 'Adequate',
    },
    letter: 'B',
    colour: {
      bg: {
        high: 'bg-janascore-b-h',
        low: 'bg-janascore-b-l',
        text: 'text-black'
      },
      border: {
        high: 'border-janascore-b-h',
        low: 'border-janascore-b-l'
      },
      hex: {
        high: '#FCDE02',
        low: '#FCDE0280'
      }
    }
  },
  '-2': {
    label: {
      short: 'Insufficient',
    },
    letter: 'C',
    colour: {
      bg: {
        high: 'bg-janascore-c-h',
        low: 'bg-janascore-c-l',
        text: 'text-white'
      },
      border: {
        high: 'border-janascore-c-h',
        low: 'border-janascore-c-l'
      },
      hex: {
        high: '#EC7808',
        low: '#EC780880'
      },
    }
  },
  '-3': {
    label: {
      short: 'Poor',
    },
    letter: 'D',
    colour: {
      bg: {
        high: 'bg-janascore-d-h',
        low: 'bg-janascore-d-l',
        text: 'text-white'
      },
      border: {
        high: 'border-janascore-d-h',
        low: 'border-janascore-d-l'
      },
      hex: {
        high: '#DB0A13',
        low: '#DB0A1380'
      },
    }
  },
  'u': {
    label: {
      short: 'Unanswered',
    },
    letter: null,
    colour: {
      bg: {
        high: 'bg-janascore-u-h',
        low: 'bg-janascore-u-l',
        text: 'text-black'
      },
      border: {
        high: 'border-janascore-u-h',
        low: 'border-janascore-u-l'
      },
      hex: {
        high: '#9B9B9B',
        low: '#9B9B9B80'
      }
    }
  },
  '-100': {
    label: {
      short: 'Unanswered',
    },
    letter: null,
    colour: {
      bg: {
        high: 'bg-janascore-u-h',
        low: 'bg-janascore-u-l',
        text: 'text-black'
      },
      border: {
        high: 'border-janascore-u-h',
        low: 'border-janascore-u-l'
      },
      hex: {
        high: '#9B9B9B',
        low: '#9B9B9B80'
      }
    }
  }
}

export const scoreMap = {
  getLabel(score, style = 'short') {
    if (score !== undefined && score !== null) {
      return map[score].label[style];
    }
  },
  
  getLetter(score) {
    if (score !== undefined && score !== null) {
      return map[score].letter;
    }
  },
  
  getColour(score, property, level = 'high') {
    if (score !== undefined && score !== null) {
      return map[score].colour[property][level];
    }
  }
}